import { render, staticRenderFns } from "./homeMain.vue?vue&type=template&id=21f3877f&scoped=true&"
import script from "./homeMain.vue?vue&type=script&lang=js&"
export * from "./homeMain.vue?vue&type=script&lang=js&"
import style0 from "./homeMain.vue?vue&type=style&index=0&id=21f3877f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3877f",
  null
  
)

export default component.exports